import HeroSection from '@/pages/home/components/HeroSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CapabilitiesSection from '@/pages/home/components/CapabilitiesSection';
import ContactFooter from '@/pages/home/components/ContactFooter';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <HeroSection />
      <AboutSection />
      <CapabilitiesSection />
      <ContactFooter />
    </main>
  );
}